module.exports = __webpack_public_path__ + "img/logo.54596e17.png";